"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.richTextHasValue = exports.hexWithoutHash = exports.getLetterFromNumber = exports.draftFieldHasValue = exports.containsCaseInsensitive = void 0;
var _draftJs = require("draft-js");
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getLetterFromNumber = exports.getLetterFromNumber = function getLetterFromNumber(number) {
  if (!(0, _isNumber["default"])(number)) {
    return;
  }
  var result = 'abcdefghijklmnopqrstuvwxyz'.charAt(number);
  return result === '' ? undefined : result;
};
var containsCaseInsensitive = exports.containsCaseInsensitive = function containsCaseInsensitive() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return a.trim().toLowerCase().indexOf(b.trim().toLowerCase()) !== -1;
};
var richTextHasValue = exports.richTextHasValue = function richTextHasValue(value) {
  return value !== undefined && value !== null && value !== '' && value.trim() !== '' && value.trim() !== '<p></p>';
};
var draftFieldHasValue = exports.draftFieldHasValue = function draftFieldHasValue(field) {
  var fieldValue = field.value && JSON.parse(field.value);
  var contentState = fieldValue && (0, _draftJs.convertFromRaw)(fieldValue);
  var hasText = contentState && contentState.hasText();
  return hasText;
};
var hexWithoutHash = exports.hexWithoutHash = function hexWithoutHash(string) {
  return string.replace('#', '');
};
//# sourceMappingURL=string-utils.js.map